import { useState } from "react";
import { Link, useLocation, Navigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { AuthLayout } from "@/components/AuthLayout";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { useAuth } from "@/context/AuthContext";
import { formatApiError } from "@/lib/api";

export default function Login() {
  const { login, user } = useAuth();
  const location = useLocation();
  const [form, setForm] = useState({ identifier: "", password: "" });
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  if (user) return <Navigate to={location.state?.from || "/feed"} replace />;

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true); setError("");
    try {
      await login(form.identifier.trim(), form.password);
    } catch (err) {
      setError(formatApiError(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <AuthLayout title="Welcome back" subtitle="Log in with the same mobile number and password you use in the Taxmandi app">
      <form onSubmit={submit} className="space-y-5" data-testid="login-form">
        <div className="space-y-2"><Label htmlFor="identifier">Mobile number or email</Label>
          <Input id="identifier" required value={form.identifier} placeholder="10-digit mobile number" onChange={(e) => setForm({ ...form, identifier: e.target.value })} className="h-11" data-testid="login-identifier-input" /></div>
        <div className="space-y-2"><Label htmlFor="password">Password</Label>
          <Input id="password" type="password" required value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} className="h-11" data-testid="login-password-input" /></div>
        {error && <p className="rounded-lg bg-red-50 px-3 py-2 text-sm text-red-700" data-testid="login-error">{error}</p>}
        <Button type="submit" disabled={busy} className="h-11 w-full rounded-full bg-tm-green hover:bg-tm-green/90" data-testid="login-submit-button">
          {busy && <Loader2 className="mr-2 h-4 w-4 animate-spin" />}Log in
        </Button>
      </form>
      <p className="mt-8 text-center text-sm text-slate-600">New to Taxmandi? <Link to="/register" className="font-semibold text-tm-green-light hover:underline" data-testid="goto-register-link">Join as professional</Link> or <Link to="/register?as=client" className="font-semibold text-tm-green-light hover:underline" data-testid="goto-register-client-link">join as client</Link></p>
    </AuthLayout>
  );
}
